<template>
    <div>
      <div>
      <table class="custom-table responsive-table border-collapse">
        <thead class="font-normal">
          <tr class="shadow-table rounded-lg opacity-50">
            <th>PERIOD</th>
            <th>
                <span class="flex items-center">
                INPUT VAT  <img
                src="@/assets/images/icons/info.svg"
                alt="information icon"
                class="ml-2"
              /></span>
            </th>
            <th>
                <span class="flex items-center">
                    OUTPUT VAT  <img
                    src="@/assets/images/icons/info.svg"
                    alt="information icon"
                    class="ml-2"
                  /></span>
            </th>
            <th>VAT REFUNDABLES /<br/>PAYABLES</th>
            <th>CUMULATIVE VAT REFUNDABLE/<br/> PAYABLES</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="rounded-lg bg-white"
            v-for="i in [1, 2, 3, 4, 5, 6, 7]"
            :key="i"
          >
            <td>july 2020</td>
            <td>N142,000</td>
            <td>N10,000</td>
            <td><span class="text-red-500">N132,000</span></td>
            <td><span class="text-red-500">N132,000</span></td>
          </tr>
        </tbody>
      </table>
  
    
   </div>

  
    </div>
  </template>
  
  <script>

  
  export default {
    props: ["bookings"],
    components: {   },
    data() {
      return {
        showFilterModal: false,
        collectPaymentModal: false,
        selectedRowId: -1,
        shareLinkModal: false,
        totalCost: 0,
        transactionId: null,
        shippingId: "",
        paylink: "",
        email: "",
        payAmount: "",
      };
    },
    computed: {
      paymentParams() {
        return {
          paylink: this.paylink,
          email: this.email,
          payAmount: this.payAmount,
        };
      },
    },
 
  };
  </script>
  
  <style lang="scss" scoped>
  .actions {
    @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
    min-width: 200px;
  }
  .actions div {
    @apply flex w-full py-2 px-2 items-center;
  }
  .icon {
    width: auto;
    padding-right: 5px;
  }
  th {
    font-weight: 300;
  }
  </style>
  